import { render, staticRenderFns } from "./CreateOrganization.vue?vue&type=template&id=25acbf41&scoped=true"
import script from "./CreateOrganization.vue?vue&type=script&lang=js"
export * from "./CreateOrganization.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganization.vue?vue&type=style&index=0&id=25acbf41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25acbf41",
  null
  
)

export default component.exports